import { render } from "./OrderRemake.vue?vue&type=template&id=2be5cdee&scoped=true"
import script from "./OrderRemake.vue?vue&type=script&lang=js"
export * from "./OrderRemake.vue?vue&type=script&lang=js"

import "./OrderRemake.vue?vue&type=style&index=0&id=2be5cdee&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be5cdee"]])

export default __exports__